import { replaceMentionValues } from "./replaceUsernames";
import { isAllMentionName } from "../../../utils/mentionUtils";

const escapeHtml = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
};

export const getUsernameFromText = (text, strings = null) => {
  if (text) {
    // mentionRegEx matches "(.)[name](id)" for any preceding char. Only treat
    // real @-mentions as mentions so markdown links like [Title](/path) stay intact.
    const replacedText = replaceMentionValues(
      replaceMentionValues(text, ({ name, id, trigger, original }) => {
        if (trigger !== "@") return original;
        if (isAllMentionName(name, id)) {
          const translatedAll = (strings && strings.All) ? strings.All : "All";
          return `<strong>@${escapeHtml(translatedAll)}</strong>`;
        }
        return `<strong>@${escapeHtml(name)}</strong>`;
      }),
      ({ id, trigger, original }) => (trigger !== "@" ? original : `${""}`)
    );
    return replacedText;
  }
  return text;
};

export const onlyUsername = (text, strings = null) => {
  const replacedText = replaceMentionValues(
    replaceMentionValues(text, ({ name, id, trigger, original }) => {
      if (trigger !== "@") return original;
      if (isAllMentionName(name, id)) {
        const translatedAll = (strings && strings.All) ? strings.All : "All";
        return `@${escapeHtml(translatedAll)}`;
      }
      return `@${escapeHtml(name)}`;
    }),
    ({ id, trigger, original }) => (trigger !== "@" ? original : `${""}`)
  );

  return replacedText;
};
